export default "__VITE_ASSET__8kM6FSi6__"